module.exports = __webpack_public_path__ + "static/media/search.d657c2ab.svg";